import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {ColorLinearProgress} from '../../src/App'
import {localization} from '../Frames/localization'

import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'


import {convert} from '../Frames/convert'
import Label from '../Elements/Label/labels'
import Operation from './ElementsPage/BoxsTransferOperation';
import '../Statement/operations.css';
import '../Statement/operationsAdaptive.css';

//settings
import {AppliedSettings} from '../../src/App' 

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}

class Transaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TabNotAvailable: false,
            key: undefined,

            asyncDisabled: false,
            progress: false,

            isLoaded: false,
            res: Array,     

            period: "",
            PointofSale: "",
            Card: "",
            startDate: "",
            endDate: "",
            page: 1,
            limit: AppliedSettings.operations_rows_num
       };      
       this.onSubsmit = this.onSubsmit.bind(this)
       this.selectPeriod = this.selectPeriod.bind(this)
       this.selectPointofSale = this.selectPointofSale.bind(this)
       this.selectType = this.selectType.bind(this)
       this.selectCard = this.selectCard.bind(this)
       this.setstartDate = this.setstartDate.bind(this)
       this.setendDate = this.setendDate.bind(this)    
       this.setPage = this.setPage.bind(this)
       this.setLimit = this.setLimit.bind(this)  
 }
    async componentWillMount()
    {
        await this.setState({limit: AppliedSettings.operations_rows_num})
    }
    componentDidMount() {
        fetch(`/api/getTransferOperations?limit=`+this.state.limit, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.data == null){
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random(),open: true})
            }
            else
            {
                this.setState({
                    res: response,
                    isLoaded: true,
                    Card: response.data.cards[0].externalCode,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    page: response.data.page,
                });
            } 
        }).catch((error) => {
            // Handle the error
            this.setState({TabNotAvailable: true})
          })
        this.forceUpdate();
      }
    onSubsmit()
    {
        this.setState({asyncDisabled: true, progress: true, period: ""})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+this.state.PointofSale+
        //`&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: 1,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,page: 1, key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    selectPeriod(value)
    {
       this.setState({period: value, asyncDisabled: true, progress: true})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+this.state.PointofSale+
        `&dateRangePreset=`+value+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: 1,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,page: 1, key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    selectPointofSale(value)
    {
       this.setState({PointofSale: value, asyncDisabled: true, progress: true})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+value+
        `&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: 1,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,page: 1, key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    selectType(value)
    {
        this.setState({Type: value, asyncDisabled: true, progress: true})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+this.state.PointofSale+
        `&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: 1,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,page: 1, key: Math.random()})
                }
        })
        this.forceUpdate();
        
    }
    selectCard(value)
    {
        this.setState({Card: value, asyncDisabled: true, progress: true})
        fetch(`/api/getTransferOperations?card=`+value+
        `&locationId=`+this.state.PointofSale+
        `&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: 1,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,page: 1, key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    setstartDate(value)
    {
        if(value > this.state.endDate)
        {
            this.setState({endDate: value})
        }
        this.setState({startDate: value})
    }
    setendDate(value)
    {
        if(value < this.state.startDate)
        {
            this.setState({startDate: value})
        }
        this.setState({endDate: value})
    }
    setPage(value)
    {
        this.setState({asyncDisabled: true, progress: true, page: value})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+this.state.PointofSale+
        `&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+this.state.limit+
        `&page=`+ value
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    asyncDisabled: false, 
                    progress: false,
                    page: response.data.page,
                    key: Math.random()});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({asyncDisabled: false, progress: false,key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    setLimit(value)
    {
        this.setState({limit: value})
        fetch(`/api/getTransferOperations?card=`+this.state.Card+
        `&locationId=`+this.state.PointofSale+
        `&dateRangePreset=`+this.state.period+
        `&startDate=`+convert.ToDateTimeStr(this.state.startDate)+
        `&endDate=`+convert.ToDateTimeStr(this.state.endDate)+
        `&limit=`+value+
        `&page=`+ 1
        , requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.error === null){
                this.setState({res: response,
                    isLoaded: true,
                    startDate: response.data.startDate,
                    endDate: response.data.endDate,
                    page: 1,});
                }else{
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({page: 1,key: Math.random()})
                }
        })
        this.forceUpdate();
    }
    render() {
        const { res, isLoaded, progress, TabNotAvailable } = this.state;
        return(
            <div>
            {TabNotAvailable == true &&
            <div className="containers">
                <div className="TabNotAvailable">
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={localization.GetTranslate('Alert.TabNotAvailable')} className="CashbackLabelNotAvailable"></Label>   
                    </Grid>
                </Grid>
                </div>                
            </div>
            } 
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            } 
            <div className="containersTransferOperation">
            {!isLoaded &&  
            TabNotAvailable == false &&
            <div class="preloader"></div>
            }  
            {isLoaded &&  
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <Operation
                            asyncDisabled={this.state.asyncDisabled}
                            onSubsmit={this.onSubsmit} 
                            res={res}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            selectPeriod={this.selectPeriod}
                            selectPointofSale={this.selectPointofSale}
                            selectType={this.selectType}
                            selectCard={this.selectCard}
                            setstartDate={this.setstartDate}
                            setendDate={this.setendDate}
                            setPage={this.setPage}
                            page={this.state.page}
                            setLimit={this.setLimit}
                            limit={this.state.limit}
                            period={this.state.period}
                            ></Operation>
                        </Grid>
                    </Grid>
            }
                    <MessageWindow key={this.state.key} ></MessageWindow>                    
            </div>
           </div>
        );
    }
}
export default Transaction;

